import React from "react";
import Link from "next/link";

import type { ArticlesProps } from "./articles.types";

import CarouselFlex from "@/components/CarouselFlex";
import CardBlog from "@/components/shared/CardBlog";

import s from "./articles.module.scss";

const Articles = ({ articles, name }: ArticlesProps) => {
  return (
    <div className={s.wrapper}>
      <div className={s.header}>
        <h2 className="heading-sm">Ler mais sobre {name}</h2>
        <Link
          className="link link-turquoise"
          target="_blank"
          href="https://blog.cobasi.com.br/?utm_source=site&utm_medium=card-racas&utm_campaign=botao-racas-ver-todos"
        >
          Ver todas
        </Link>
      </div>
      <div className={s.show_case_articles}>
        <CarouselFlex
          className="carousel-flex"
          classNameArrow="btn outlined btn-icon-rounded btn-md btn-turquoise arrow"
          showArrows
        >
          {articles.map((article) => (
            <CardBlog {...article} key={article.slug} />
          ))}
        </CarouselFlex>
      </div>
    </div>
  );
};

export default Articles;
